module.exports = {
  // TODO: Figure out which fields are actually needed here then remove the rest from all properties
  gatsbyConfig: {
    property: 'powdr',
    copyrightTagline: 'POWDR',
    siteName: 'POWDR',
    siteUrl: 'https://www.powdr.com/',
    reCaptchaDBPropertyName: 'Powdr',
    reCaptchaPublicKey: '6LfiiYIUAAAAAEvSxGg7A_ZOQRemWMgGBoTr0Z5P',
    givebutterAccountID: 'GTLL9bqJ9GTRia2n',
    color: '#64CAC7',
    facebook: 'borealmtn',
    instagram: 'borealmtn',
    twitter: 'borealmtn',
    dynamicTypes: [
      'news',
    ],
    ignore404Routes: [
      '/news/powdr-news',
    ],
  },
  // TODO: Good way of managing API keys per site, maybe use for formbucket and mailchimp?
  contentfulConfig: {
    spaceId: '38vc2unmqsq5',
    accessToken: 'D2b0ZG2uKbPvWdW38GS0y3_hQN9AxH-iJnKijjoI0cA',
  },
};
